"use client";

import { usePathname } from "@/i18n/routing";
import { cn } from "@heroui/react";
import { ReactNode } from "react";
const defaultSectionClass =
  "mx-auto min-h-[calc(100svh-var(--bottom-navbar-height))] w-full px-4 pb-[calc(var(--bottom-navbar-height)+1.25rem)] pt-4 sm:px-8 lg:max-w-screen-md lg:px-0";
const defaultChildClass = "relative grid w-full grid-cols-1 px-4 md:px-2";
export default function Section({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  switch (pathname) {
    case "/notification":
      return (
        <section className={cn(defaultSectionClass, "flex flex-col items-center justify-center")}>
          <div className={cn(defaultChildClass, "my-auto h-full")}>{children}</div>
        </section>
      );
    case "/referral":
      return (
        <section className={cn(defaultSectionClass, "!pt-0")}>
          <div className={cn(defaultChildClass)}>{children}</div>
        </section>
      );
    case "/rewards":
      return <section className={cn(defaultSectionClass, "h-full")}>{children}</section>;
    case "/profile/promo-code":
    case "/rewards/daily":
      return <>{children}</>
    default:
      return <section className={cn(defaultSectionClass)}>{children}</section>;
  }
}
